// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";

// const AddressPage = () => {
//   const [user, setUser] = useState({
//     firstname: "",
//     email: "",
//     mob_number: "",
//   });

//   const [addresses, setAddresses] = useState([]);
//   const [currentAddress, setCurrentAddress] = useState({
//     fullName: "",
//     phoneNumber: "",
//     email: "",
//     addressLine1: "",
//     addressLine2: "",
//     city: "",
//     state: "",
//     pinCode: "",
//     country: "",
//   });
//   const [isEditing, setIsEditing] = useState(false);
//   const [currentEditIndex, setCurrentEditIndex] = useState(null);

//   useEffect(() => {
//     // Fetch user data
//     const fetchUserData = async () => {
//       try {
//         const response = await axios.get("/api/profile");
//         setUser(response.data);
//       } catch (error) {
//         console.error("Error fetching user data", error);
//       }
//     };

//     // Fetch addresses
//     const fetchAddresses = async () => {
//       try {
//         const response = await axios.get("/api/addresses");
//         setAddresses(Array.isArray(response.data) ? response.data : []);
//       } catch (error) {
//         console.error("Error fetching addresses", error);
//       }
//     };

//     fetchUserData();
//     fetchAddresses();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCurrentAddress({ ...currentAddress, [name]: value });
//   };

//   const saveAddress = async () => {
//     try {
//       if (isEditing && currentEditIndex !== null) {
//         // Update address
//         const response = await axios.put(
//           `/api/addresses/${addresses[currentEditIndex]._id}`,
//           currentAddress
//         );
//         const updatedAddresses = [...addresses];
//         updatedAddresses[currentEditIndex] = response.data;
//         setAddresses(updatedAddresses);
//       } else {
//         // Add new address
//         const response = await axios.post(
//           "/api/addresses",
//           currentAddress
//         );
//         setAddresses([...addresses, response.data]);
//       }
//       setIsEditing(false);
//       setCurrentEditIndex(null);
//       setCurrentAddress({
//         fullName: "",
//         phoneNumber: user.mob_number || "",
//         email: user.email || "",
//         addressLine1: "",
//         addressLine2: "",
//         city: "",
//         state: "",
//         pinCode: "",
//         country: "",
//       });
//     } catch (error) {
//       console.error("Error saving address", error);
//       alert("Failed to save address");
//     }
//   };

//   const editAddress = (index) => {
//     setIsEditing(true);
//     setCurrentEditIndex(index);
//     setCurrentAddress(addresses[index]);
//   };

//   return (
//     <div className="address-page">
//       <div className="breadcrumb-wrap bg-f br-2 mt-5">
//         <div className="container">
//           <div className="breadcrumb-title">
//             <h2>Products</h2>
//             <ul className="breadcrumb-menu list-style">
//               <li><Link to="#">Home </Link></li>
//               <li>Products</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//       <h2>Manage Addresses</h2>
//       <div className="address-form">
//         <h3>{isEditing ? "Edit Address" : "Add New Address"}</h3>
//         <input
//           type="text"
//           name="fullName"
//           value={currentAddress.fullName}
//           onChange={handleChange}
//           placeholder="Full Name"
//         />
//         <input
//           type="text"
//           name="phoneNumber"
//           value={currentAddress.phoneNumber || user.mob_number}
//           onChange={handleChange}
//           placeholder="Phone Number"
//         />
//         <input
//           type="email"
//           name="email"
//           value={currentAddress.email || user.email}
//           onChange={handleChange}
//           placeholder="Email"
//         />
//         <input
//           type="text"
//           name="addressLine1"
//           value={currentAddress.addressLine1}
//           onChange={handleChange}
//           placeholder="Address Line 1"
//         />
//         <input
//           type="text"
//           name="addressLine2"
//           value={currentAddress.addressLine2}
//           onChange={handleChange}
//           placeholder="Address Line 2"
//         />
//         <input
//           type="text"
//           name="city"
//           value={currentAddress.city}
//           onChange={handleChange}
//           placeholder="City"
//         />
//         <input
//           type="text"
//           name="state"
//           value={currentAddress.state}
//           onChange={handleChange}
//           placeholder="State"
//         />
//         <input
//           type="text"
//           name="pinCode"
//           value={currentAddress.pinCode}
//           onChange={handleChange}
//           placeholder="Pin Code"
//         />
//         <input
//           type="text"
//           name="country"
//           value={currentAddress.country}
//           onChange={handleChange}
//           placeholder="Country"
//         />
//         <button onClick={saveAddress}>{isEditing ? "Update" : "Add"} Address</button>
//       </div>
//       <div className="address-list">
//         <h3>Saved Addresses</h3>
//         {addresses.map((address, index) => (
//           <div key={index} className="address-item">
//             <p><strong>{address.fullName}</strong></p>
//             <p>{address.phoneNumber}</p>
//             <p>{address.email}</p>
//             <p>{address.addressLine1}</p>
//             <p>{address.addressLine2}</p>
//             <p>{address.city}, {address.state} - {address.pinCode}</p>
//             <p>{address.country}</p>
//             <button onClick={() => editAddress(index)}>Edit</button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AddressPage;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { MdEdit } from "react-icons/md";
import { Link } from "react-router-dom";
import './useraddress.css'
import Usernav from "../usernav/usernav";
import { MdDelete } from "react-icons/md";
const AddressPage = () => {
  const [user, setUser] = useState({
    firstname: "",
    email: "",
    mob_number: "",
  });

  const [addresses, setAddresses] = useState([]);
  const [currentAddress, setCurrentAddress] = useState({
    fullName: "",
    phoneNumber: localStorage.getItem("phoneNumber"),
    email: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [currentEditIndex, setCurrentEditIndex] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get("/api/profile");
        setUser(response.data);
      } catch (error) {
        console.error("Error fetching user data", error);
      }
    };

    const fetchAddresses = async () => {
      const phoneNumber = localStorage.getItem('phoneNumber');
      try {
        const response = await axios.get(`/api/address/${phoneNumber}`);
        setAddresses(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching addresses", error);
      }
    };

    fetchUserData();
    fetchAddresses();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentAddress({ ...currentAddress, [name]: value });
  };

  const saveAddress = async () => {
    try {
      if (isEditing && currentEditIndex !== null) {
        const response = await axios.put(
          `/api/addresses/${addresses[currentEditIndex]._id}`,
          currentAddress
        );
        const updatedAddresses = [...addresses];
        updatedAddresses[currentEditIndex] = response.data;
        setAddresses(updatedAddresses);
      } else {
        const response = await axios.post(
          "/api/addresses",
          currentAddress
        );
        setAddresses([...addresses, response.data]);
      }
      setIsEditing(false);
      setCurrentEditIndex(null);
      setCurrentAddress({
        fullName: "",
        phoneNumber: user.mob_number || "",
        email: user.email || "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pinCode: "",
        country: "",
      });
    } catch (error) {
      console.error("Error saving address", error);
      alert("Failed to save address");
    }
  };
  const deleteAddress = async (id) => {
    try {
      // Send DELETE request to backend
      await axios.delete(`/api/addresses/${id}`);
  
      // Update the addresses state to remove the deleted address
      const updatedAddresses = addresses.filter((address) => address._id !== id);
      setAddresses(updatedAddresses);
    } catch (error) {
      console.error("Error deleting address", error);
      alert("Failed to delete address");
    }
  };
  
  const editAddress = (index) => {
    setIsEditing(true);
    setCurrentEditIndex(index);
    setCurrentAddress(addresses[index]);
  };

  return (
<div className="address-page">
  <div className="breadcrumb-wrap bg-f br-2">
    <div className="container">
      <div className="breadcrumb-title">
        <h2>Manage Addresses</h2>
        <ul className="breadcrumb-menu list-style">
          <li><Link to="/">Home</Link></li>
          <li>Manage Addresses</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="containerorder">
        <div className="row ">
          <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
          <Usernav /></div>
          <div className="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
  <div className="address-list">
      <h3>Saved Addresses</h3>
      <div className="address-table">
        <table>
          <thead>
            <tr>
              <th>Full Name</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {addresses.map((address, index) => (
              <tr key={index}>
                <td>{address.fullName}</td>
                <td>{address.phoneNumber}</td>
                <td>{address.email}</td>
                <td>
                  {address.addressLine1}, {address.addressLine2}, {address.city}, {address.state} - {address.pinCode}
                </td>
                <td >
                  <div className="d-flex">
                  <button className="button"onClick={() => editAddress(index)}><MdEdit /></button>
                  <br/>
                  <button className="delete-btn" onClick={() => deleteAddress(address._id)}><MdDelete /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    <div className="address-form">
      <h3>{isEditing ? "Edit Address" : "Add New Address"}</h3>
      <div className="d-flex gap-2">
      <input
        type="text"
        name="fullName"
        value={currentAddress.fullName}
        onChange={handleChange}
        placeholder="Full Name"
      />
      <input
        type="text"
        name="phoneNumber"
        value={currentAddress.phoneNumber || user.mob_number}
        onChange={handleChange}
        placeholder="Phone Number"
      />
      <input
        type="email"
        name="email"
        value={currentAddress.email || user.email}
        onChange={handleChange}
        placeholder="Email"
      /></div>
      <input
        type="text"
        name="addressLine1"
        value={currentAddress.addressLine1}
        onChange={handleChange}
        placeholder="Address Line 1"
      />
      <input
        type="text"
        name="addressLine2"
        value={currentAddress.addressLine2}
        onChange={handleChange}
        placeholder="Address Line 2"
      />
      <div className="d-flex gap-2">
      <input
        type="text"
        name="city"
        value={currentAddress.city}
        onChange={handleChange}
        placeholder="City"
      />
      <input
        type="text"
        name="state"
        value={currentAddress.state}
        onChange={handleChange}
        placeholder="State"
      />

      <input
        type="text"
        name="pinCode"
        value={currentAddress.pinCode}
        onChange={handleChange}
        placeholder="Pin Code"
      />
      <input
        type="text"
        name="country"
        value={currentAddress.country}
        onChange={handleChange}
        placeholder="Country"
      /></div>
      <button className="button"onClick={saveAddress}>{isEditing ? "Update" : "Add"} Address</button>
    </div>

  </div>
  </div>
  </div>
</div>

  );
};

export default AddressPage;
